// Keep in sync with backend/app/core/modules.py.
export const MODULES = [
  { key: 'customers', label: 'Müşteriler' },
  { key: 'crm', label: 'Satış Hunisi / Görevler' },
  { key: 'products', label: 'Ürün/Hizmetler' },
  { key: 'quotes', label: 'Teklifler' },
  { key: 'hakedis', label: 'Hakedişler' },
  { key: 'inventory', label: 'Envanter / Depolar' },
  { key: 'bom', label: 'Montaj (BOM) / Eşdeğer Ürünler' },
  { key: 'sourcing', label: 'Tedarik' },
  { key: 'purchase_orders', label: 'Satın Alma' },
];

export function getUser() {
  return JSON.parse(localStorage.getItem('user') || '{}');
}

// Admins can use every module; everyone else only the ones granted to them.
export function hasModule(user, key) {
  return !!user.is_admin || (user.modules || []).includes(key);
}
